export default "__VITE_ASSET__C2po9hmu__";